<div class="sidenav-wrapper">
  @if (translationsHaveLoaded$ | async) {
    <mat-sidenav-container class="sidenav-container">

      <mat-sidenav
        [disableClose]="!(isXSmall$ | async)"
        [class.collapsed]="isDrawerCollapsed()"
        [class.isXSmall]="isXSmall$ | async"
        class="sidenav"
        [attr.role]="(isXSmall$ | async) ? 'dialog' : 'navigation'"
        [mode]="sidenavMode$ | async"
        [opened]="sidenavOpened$ | async"
        >
        <mat-toolbar>
          @if (showLogo) {
            <a routerLink="">
              @if (hasCustomLogoComponent$ | async) {
                <app-ovivio-logo [title]="logoTitle$ | async"></app-ovivio-logo>
              } @else {
                <img class="logo" [src]="logoUrl$ | async" [alt]="'generic.app_name' | translate" />
              }
            </a>
          }
        </mat-toolbar>

        <div class="sidenav-organization-selector">
          <app-organization-unit-selector [extended]="true"></app-organization-unit-selector>
        </div>
        <mat-nav-list>
          @for (route of routes$ | async; track route) {
            @if (route.isEnabled$ | async) {
              @let badgeValue = route.badgeValue$ | async;
              @if (route.routerLink) {
                <mat-list-item
                  class="hvr-forward"
                  [routerLink]="route.routerLink"
                  matTooltipPosition="right"
                  [matTooltipShowDelay]="100"
                  [matTooltip]="route.name | translate: route.nameParams || {}"
                  [matTooltipDisabled]="!isDrawerCollapsed()"
                  >
                  @if(route.icon.includes('-')) {
                    <mat-icon
                      matListItemIcon
                      [matBadgeColor]="badgeValue ? 'primary' : undefined"
                      [matBadge]="badgeValue || undefined"
                      [svgIcon]="route.icon"
                    ></mat-icon>
                  } @else {
                    <mat-icon
                      matListItemIcon
                      [matBadgeColor]="badgeValue ? 'primary' : undefined"
                      [matBadge]="badgeValue || undefined"
                    >{{ route.icon }}</mat-icon>
                  }
                  <span matListItemTitle>{{ route.name | translate: route.nameParams || {} }}</span>
                </mat-list-item>
              }
              @if (!route.routerLink && route.url) {
                <a
                  mat-list-item
                  class="hvr-forward navigation-link"
                  [href]="route.url"
                  target="_blank"
                  matTooltipPosition="right"
                  [matTooltipShowDelay]="100"
                  [matTooltip]="route.name | translate: route.nameParams || {}"
                  [matTooltipDisabled]="!isDrawerCollapsed()"
                  >
                  @if(badgeValue) {
                  <mat-icon
                    matListItemIcon
                    matBadgeColor="primary"
                    [matBadge]="badgeValue"
                  >help</mat-icon>
                  } @else {
                    <mat-icon
                    matListItemIcon
                    matBadgeColor="primary"
                  >help</mat-icon>
                  }
                  @if (!isDrawerCollapsed()) {
                    <h4 matListItemTitle>{{ route.name | translate: route.nameParams || {} }}</h4>
                  }
                </a>
              }
            }
          }
        </mat-nav-list>
        <app-profile-panel></app-profile-panel>
        <div class="bg-overlay"></div>
        <div style="flex: 1"></div>
        @if (!isDrawerCollapsed() && (showPoweredByLogo$ | async)) {
          <a routerLink="" class="footer-logo">
            <img [src]="poweredByLogo$ | async" />
          </a>
        }
        @if (!(isXSmall$ | async)) {
          <footer (click)="toggleDrawerCollapseState()">
            <p class="build-version">{{ buildVersion ?? '' }}</p>
            <button mat-icon-button class="chevron">
              <mat-icon>chevron_left</mat-icon>
            </button>
          </footer>
        }
      </mat-sidenav>
      <mat-sidenav-content id="sidenav-content">
        <router-outlet #o="outlet"></router-outlet>
      </mat-sidenav-content>
    </mat-sidenav-container>
  }
</div>
